export default __webpack_public_path__ + "static/media/austria.842c658d.svg";